import { useReducer, useEffect, useMemo } from "react";
import { Form } from "antd";
import { apiaxios } from "../../config/axios";
import { Endpoints } from "../../config/type_endpoints";
import { MessageType } from "../../types/messageType";
import { MessageAnt } from "../../redux/slices/ui/uiAction";
import { replaceIdURL } from "../../helpers/replaceId";
import { createRequestCategory, deleteRequestCategory, getAllRequestCategories } from "../../config";
import { columnsCategory } from "../../types/columnsTables/columnCategory";

const initialState = {
    isLoading: false,
    searchValue: "",
    tableData: [],
    tablePagination: 0,
    activeModal: false,
    typeModal: 0,
    activeSubModal: false,
    dataCategoryForm: {},
    dataSubcategoryForm: {},
    selectedCategory: "",
    loadingButton: false,
};

function reducer(state, action) {
    switch (action.type) {
        case "SET_LOADING":
            return { ...state, isLoading: action.payload };
        case "SET_SEARCH_VALUE":
            return { ...state, searchValue: action.payload };
        case "SET_TABLE_DATA":
            return { ...state, tableData: action.payload };
        case "SET_TABLE_PAGINATION":
            return { ...state, tablePagination: action.payload };
        case "SET_ACTIVE_MODAL":
            return { ...state, activeModal: action.payload };
        case "SET_TYPE_MODAL":
            return { ...state, typeModal: action.payload };
        case "SET_ACTIVE_SUB_MODAL":
            return { ...state, activeSubModal: action.payload };
        case "SET_DATA_CATEGORY_FORM":
            return { ...state, dataCategoryForm: action.payload };
        case "SET_DATA_SUBCATEGORY_FORM":
            return { ...state, dataSubcategoryForm: action.payload };
        case "SET_SELECTED_CATEGORY":
            return { ...state, selectedCategory: action.payload };
        case "SET_LOADING_BUTTON":
            return { ...state, loadingButton: action.payload };
        default:
            throw new Error(`Unknown action type: ${action.type}`);
    }
}

export const usePageCategoriesData = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [categoryForm] = Form.useForm();
    const [subCategoryForm] = Form.useForm();

    const getAllCategories = async () => {
        dispatch({ type: "SET_LOADING", payload: true });
        const { status, payload } = await getAllRequestCategories();
        if (status > 0) {
            MessageAnt(MessageType.error, `Error de servidor`);
        } else {
            const newCategory = payload.map((category) => {
                const subCategories = [];
                if (category.subCategories) {
                    category.subCategories.forEach((element, index) => {
                        subCategories.push({
                            key: `${index}-subcategorycolumn`,
                            namesub: element,
                        });
                    });
                }
                return {
                    key: category._id,
                    ...category,
                    subCategories: subCategories,
                };
            });
            dispatch({ type: "SET_TABLE_DATA", payload: newCategory });
            dispatch({ type: "SET_TABLE_PAGINATION", payload: newCategory.length });
            dispatch({ type: "SET_LOADING", payload: false });
        }
    };

    const createCategory = async (form) => {
        dispatch({ type: "SET_LOADING_BUTTON", payload: true });
        const { status } = await createRequestCategory(form);
        if (status > 0) {
            MessageAnt(MessageType.error, `Error al crear categorias`);
        } else {
            MessageAnt(MessageType.success, `Se creo categoria`);
            getAllCategories();
        }
        dispatch({ type: "SET_LOADING_BUTTON", payload: false });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
    };

    const editCategory = async (form) => {
        try {
            const url = replaceIdURL(Endpoints.category.put_delete, "id", state.selectedCategory);
            const { data: categoryApi } = await apiaxios.put(`${url}`, form);
            getAllCategories();
            if (categoryApi.status > 0) {
                console.log(categoryApi);
                MessageAnt(MessageType.error, `Error al editar categoria`);
            } else {
                MessageAnt(MessageType.success, `Se edito categoria ${form.name}`);
            }
        } catch (error) {
            console.log(error);
            MessageAnt(MessageType.error, `Error de servidor`);
        } finally {
            dispatch({ type: "SET_LOADING_BUTTON", payload: false });
            dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
            dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        }
    };

    const deleteAction = async (id) => {
        const { status } = await deleteRequestCategory(id);
        if (status > 0) {
            MessageAnt(MessageType.error, `Error al eliminar categorias`);
        } else {
            MessageAnt(MessageType.success, `Se elimino categoria`);
            getAllCategories();
        }
    };

    const editAction = async (form) => {
        if (form) {
            dispatch({ type: "SET_DATA_CATEGORY_FORM", payload: { ...form } });
            dispatch({ type: "SET_SELECTED_CATEGORY", payload: form.key });
        }
        dispatch({ type: "SET_TYPE_MODAL", payload: 1 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: true });
    };

    const editSubcategoryAction = (form) => {
        console.log(form);
        if (form) {
            dispatch({ type: "SET_DATA_SUBCATEGORY_FORM", payload: form });
            dispatch({ type: "SET_SELECTED_CATEGORY", payload: form.key });
        }
        dispatch({ type: "SET_ACTIVE_SUB_MODAL", payload: true });
    };

    const addSubCategory = async (form) => {
        try {
            const newForm = form.subCategories.map((category) => category.namesub);
            const url = replaceIdURL(Endpoints.category.addsubcategories, "categoryId", state.selectedCategory);
            const { data: categoryApi } = await apiaxios.put(`${url}`, { names: newForm });
            if (categoryApi.status > 0) {
                console.log(categoryApi);
                MessageAnt(MessageType.error, `Error al editar categoria`);
            } else {
                MessageAnt(MessageType.success, `Se edito categoria ${state.dataSubcategoryForm.name}`);
            }
            getAllCategories();
        } catch (error) {
            console.log(error);
            MessageAnt(MessageType.error, `Error de servidor`);
        } finally {
            dispatch({ type: "SET_LOADING_BUTTON", payload: false });
            dispatch({ type: "SET_ACTIVE_SUB_MODAL", payload: false });
        }
    };

    const handleOpenModalCreate = () => {
        dispatch({ type: "SET_DATA_CATEGORY_FORM", payload: { isActive: true, name: "" } });
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: true });
    };

    const closeModal = () => {
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
    };

    const closeSubModal = () => {
        dispatch({ type: "SET_ACTIVE_SUB_MODAL", payload: false });
    };

    const onFinishSubCategory = (values) => {
        dispatch({ type: "SET_LOADING_BUTTON", payload: true });
        const structureForm = {
            ...values,
        };
        addSubCategory(structureForm);
    };

    const onFinishCategory = (values) => {
        dispatch({ type: "SET_LOADING_BUTTON", payload: true });
        const structureForm = {
            ...values,
        };
        if (state.typeModal === 0) {
            createCategory(structureForm);
        } else {
            editCategory(structureForm);
        }
    };
    const handleChange = (e) => {
        dispatch({ type: "SET_SEARCH_VALUE", payload: e.target.value });
    };

    const { columns, props } = columnsCategory(editAction, deleteAction, state.tablePagination, editSubcategoryAction);
    const { pagination, ...tableProps } = props;

    const tableFilterDataCategories = useMemo(() => {
        return state.tableData.filter((item) => {
            const nameMatches = item.name.toLowerCase().includes(state.searchValue.toLowerCase());
            const namesubMatches = item.subCategories.some((subcategory) =>
                subcategory.namesub.toLowerCase().includes(state.searchValue.toLowerCase())
            );

            return nameMatches || namesubMatches;
        });
    }, [state.tableData, state.searchValue]);

    useEffect(() => {
        subCategoryForm.setFieldsValue({
            ...state.dataSubcategoryForm,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.dataSubcategoryForm]);

    useEffect(() => {
        categoryForm.setFieldsValue({
            ...state.dataCategoryForm,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.dataCategoryForm]);

    useEffect(() => {
        getAllCategories();
    }, []);

    return {
        searchValue: state.searchValue,
        activeModal: state.activeModal,
        activeSubModal: state.activeSubModal,
        typeModal: state.typeModal,
        loadingButton: state.loadingButton,
        categoryForm,
        subCategoryForm,
        isLoading: state.isLoading,
        handleOpenModalCreate,
        closeModal,
        closeSubModal,
        onFinishCategory,
        onFinishSubCategory,
        tableFilterDataCategories,
        handleChange,
        columns,
        tableProps,
        pagination,
    };
};
